import { frontendURL } from 'dashboard/helper/URLHelper';
import EssentialConversationView from './EssentialConversationView.vue';
import EssentialAdminView from './EssentialAdminView.vue';

const CONVERSATION_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/essential'),
      name: 'essential_home',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: EssentialConversationView,
      props: () => ({ conversationId: 0 }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/essential/conversations/:conversation_id'
      ),
      name: 'essential_conversation',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: EssentialConversationView,
      props: route => ({ conversationId: route.params.conversation_id }),
    },
    {
      path: frontendURL('accounts/:accountId/essential/admin'),
      name: 'essential_admin',
      meta: {
        permissions: ['administrator'],
      },
      component: EssentialAdminView,
    },
  ],
};
